import React, { useState, useEffect } from "react";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Checkbox } from "../components/ui/checkbox";
import { Label } from "../components/ui/label";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Kontakt() {
  const [form, setForm] = useState({
    name: "",
    unternehmen: "",
    email: "",
    telefon: "",
    nachricht: "",
    datenschutz: false,
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    document.title =
      "Kontakt – Kostenlose Ersteinschätzung | Rechtsanwalt Sindros";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "Kontaktieren Sie Rechtsanwalt Sindros für eine kostenlose Ersteinschätzung Ihrer Bewertungssituation."
      );
  }, []);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.nachricht) {
      toast.error("Bitte füllen Sie alle Pflichtfelder aus.");
      return;
    }
    if (!form.datenschutz) {
      toast.error("Bitte bestätigen Sie die Datenschutzerklärung.");
      return;
    }
    setSubmitting(true);
    try {
      const response = await axios.post(`${API}/contact`, {
        name: form.name,
        unternehmen: form.unternehmen,
        email: form.email,
        telefon: form.telefon,
        nachricht: form.nachricht,
      });
      setSubmitted(true);
      toast.success(response.data.message || "Ihre Nachricht wurde erfolgreich gesendet.");
    } catch (err) {
      toast.error("Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div>
        <section className="bg-white">
          <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 lg:py-28 text-center">
            <h1
              className="text-3xl font-bold mb-6"
              style={{
                color: "#1B3A5C",
                fontFamily: "'Source Serif 4', serif",
              }}
            >
              Vielen Dank für Ihre Nachricht
            </h1>
            <p className="text-base mb-8" style={{ color: "#555555" }}>
              Wir werden uns zeitnah bei Ihnen melden.
            </p>
            <button
              onClick={() => {
                setSubmitted(false);
                setForm({
                  name: "",
                  unternehmen: "",
                  email: "",
                  telefon: "",
                  nachricht: "",
                  datenschutz: false,
                });
              }}
              className="inline-block px-6 py-3 text-white font-medium text-sm rounded"
              style={{
                backgroundColor: "#1B3A5C",
                transition: "opacity 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.88")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              Neue Nachricht senden
            </button>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div>
      {/* Hero */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <h1
            className="text-4xl lg:text-5xl font-bold mb-6"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            Kontakt aufnehmen
          </h1>
          <p className="text-lg max-w-2xl" style={{ color: "#555555" }}>
            Sie haben Fragen zu Ihren Rechten im Internet oder möchten eine
            kostenlose Ersteinschätzung Ihrer Bewertungssituation? Kontaktieren
            Sie mich.
          </p>
        </div>
      </section>

      {/* Form + Info */}
      <section style={{ backgroundColor: "#F5F5F5" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
            {/* Form */}
            <div className="lg:col-span-3">
              <form
                onSubmit={handleSubmit}
                className="bg-white rounded-lg p-8 lg:p-10 shadow-sm space-y-6"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <Label
                      htmlFor="name"
                      className="text-sm font-medium"
                      style={{ color: "#333333" }}
                    >
                      Name <span style={{ color: "#2E75B6" }}>*</span>
                    </Label>
                    <Input
                      id="name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Ihr Name"
                      required
                      className="border-gray-300"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label
                      htmlFor="unternehmen"
                      className="text-sm font-medium"
                      style={{ color: "#333333" }}
                    >
                      Unternehmen
                    </Label>
                    <Input
                      id="unternehmen"
                      name="unternehmen"
                      value={form.unternehmen}
                      onChange={handleChange}
                      placeholder="Ihr Unternehmen (optional)"
                      className="border-gray-300"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <Label
                      htmlFor="email"
                      className="text-sm font-medium"
                      style={{ color: "#333333" }}
                    >
                      E-Mail <span style={{ color: "#2E75B6" }}>*</span>
                    </Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="Ihre E-Mail-Adresse"
                      required
                      className="border-gray-300"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label
                      htmlFor="telefon"
                      className="text-sm font-medium"
                      style={{ color: "#333333" }}
                    >
                      Telefon
                    </Label>
                    <Input
                      id="telefon"
                      name="telefon"
                      value={form.telefon}
                      onChange={handleChange}
                      placeholder="Ihre Telefonnummer (optional)"
                      className="border-gray-300"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <Label
                    htmlFor="nachricht"
                    className="text-sm font-medium"
                    style={{ color: "#333333" }}
                  >
                    Nachricht <span style={{ color: "#2E75B6" }}>*</span>
                  </Label>
                  <Textarea
                    id="nachricht"
                    name="nachricht"
                    value={form.nachricht}
                    onChange={handleChange}
                    placeholder="Beschreiben Sie Ihr Anliegen..."
                    rows={6}
                    required
                    className="border-gray-300 resize-none"
                  />
                </div>

                <div className="flex items-start gap-3">
                  <Checkbox
                    id="datenschutz"
                    checked={form.datenschutz}
                    onCheckedChange={(checked) =>
                      setForm((prev) => ({ ...prev, datenschutz: checked }))
                    }
                    className="mt-0.5"
                  />
                  <Label
                    htmlFor="datenschutz"
                    className="text-sm leading-relaxed cursor-pointer"
                    style={{ color: "#555555" }}
                  >
                    Ich habe die{" "}
                    <a
                      href="/datenschutz"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline"
                      style={{ color: "#2E75B6" }}
                    >
                      Datenschutzerklärung
                    </a>{" "}
                    gelesen.
                  </Label>
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-4 text-white font-medium text-sm rounded disabled:opacity-60"
                  style={{
                    backgroundColor: "#1B3A5C",
                    transition: "opacity 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!submitting) e.currentTarget.style.opacity = "0.88";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = "1";
                  }}
                >
                  {submitting ? "Wird gesendet..." : "Nachricht senden"}
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="lg:col-span-2">
              <div className="space-y-8">
                <div>
                  <h2
                    className="text-xl font-bold mb-4"
                    style={{ color: "#1B3A5C" }}
                  >
                    Rechtsanwalt Sindros
                  </h2>
                  <p
                    className="text-sm leading-relaxed"
                    style={{ color: "#555555" }}
                  >
                    Kanzlei für Internetrecht &amp; Reputationsmanagement
                  </p>
                </div>

                <div className="space-y-3">
                  <p className="text-sm" style={{ color: "#555555" }}>
                    <span
                      className="font-medium"
                      style={{ color: "#333333" }}
                    >
                      E-Mail:
                    </span>{" "}
                    info@fairebewertungen.de
                  </p>
                  <p className="text-sm" style={{ color: "#555555" }}>
                    <span
                      className="font-medium"
                      style={{ color: "#333333" }}
                    >
                      Telefon:
                    </span>{" "}
                    +49 178 4660549
                  </p>
                </div>

                <div>
                  <p
                    className="text-sm font-medium mb-2"
                    style={{ color: "#333333" }}
                  >
                    Erreichbarkeit:
                  </p>
                  <p className="text-sm" style={{ color: "#555555" }}>
                    Montag – Freitag, 9:00 – 18:00 Uhr
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
          <div
            className="rounded-lg p-10 lg:p-16 text-center"
            style={{ backgroundColor: "#F5F5F5" }}
          >
            <h2
              className="text-2xl font-bold mb-4"
              style={{
                color: "#1B3A5C",
                fontFamily: "'Source Serif 4', serif",
              }}
            >
              Sie möchten direkt eine Bewertung löschen lassen?
            </h2>
            <p className="text-base mb-8" style={{ color: "#555555" }}>
              Besuchen Sie unseren spezialisierten Service:
            </p>
            <a
              href="https://www.fairebewertungen.de"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 text-white font-medium text-sm rounded"
              style={{
                backgroundColor: "#1B3A5C",
                transition: "opacity 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.88")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              Zu Fairebewertungen.de
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
